import { render, staticRenderFns } from "./TheUserInput.vue?vue&type=template&id=5523ec6e&scoped=true"
import script from "./TheUserInput.vue?vue&type=script&lang=js"
export * from "./TheUserInput.vue?vue&type=script&lang=js"
import style0 from "./TheUserInput.vue?vue&type=style&index=0&id=5523ec6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523ec6e",
  null
  
)

export default component.exports